import axios from 'axios'
import { ascending } from 'd3-array'

import { REPORT_VIEWERS } from './constants'
import newPageLayout from './editor/new-page-layout.json'

class ReportService {
  async createReportPage (title, category = { label: '' }, viewer = REPORT_VIEWERS.PAGE, reportId) {
    return axios.post(`api/report/${reportId}/page`, {
      title,
      viewer,
      group: category,
      layout: newPageLayout
    })
  }

  async getReport (reportId, version, parentVersion) {
    const { data } = await axios.get(`api/report/${reportId}`, { params: { version, parentVersion } })
    return data
  }

  async checkReportDuplicateStatus (reportId) {
    const { data } = await axios.get(`api/report/${reportId}/data/status?operation=duplicate-report-data`)
    return data
  }

  async duplicateReport (reportId, title, description, alias) {
    const { data } = await axios.post(`api/report/${reportId}/duplicate`, { title, description, alias })
    return data
  }

  async getCategories (reportId, version) {
    const params = {}

    if (version) {
      params.version = version
    }

    const { data } = await axios.get(`api/report/${reportId}/groups`, { params })
    return data.map((group) => ({ value: group.id, label: group.label }))
  }

  async updateReportToc (reportId, changes) {
    return axios.post(`api/report/${reportId}`, changes)
  }

  hasCommentAccess (report) {
    return ['owner', 'writer', 'reviewer'].includes(report.userRole)
  }

  buildPageRoute (report, pageId, version, mode = 'view') {
    const pageListReport = (report && Object.keys(report.parent).length > 0) ? report.parent : report
    let pageRoute = `/reports/${pageId}/${mode}`

    // Only pass the version if the parent version is not the latest
    if (pageListReport.version < pageListReport.versionCount) {
      pageRoute += `?version=${version}&parentVersion=${pageListReport.version}`
    }

    return pageRoute
  }

  getPaginationLink ({ report, parentVersion, type = 'next' }) {
    if (!['next', 'prev'].includes(type)) {
      console.warn(`Invalid pagination link type: ${type}. Setting to "next"`)
    }
    const action = report.actions[type]
    if (!action) {
      return ''
    }

    const parentVersionParam = parentVersion ? `&parentVersion=${parentVersion}` : ''
    return `/reports/${action.id}/view?version=${action.version}${parentVersionParam}`
  }

  sortReportsByTitle (reports) {
    const getCompareValue = (report) => {
      let value = report.title || ''
      return value.toLocaleLowerCase()
    }

    return reports.sort((a, b) => ascending(getCompareValue(a), getCompareValue(b)))
  }
}

export const reportService = new ReportService()
